














































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { List, Toast } from 'vant';
import { getList } from '../api';
import SearchBar from '../components/SearchBar.vue';
import Item from './Item.vue';
Vue.use(List);
@Component({
  components: {
    SearchBar,
    Item,
  },
})
export default class VoteList extends Vue {
  @Prop({ default: 1 }) idtype!: number;
  id = 1;
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  placeholder: string = '请输入作者或作品名称';
  inputText: string = '';
  voteList: any[] = [];
  word = '';
  show: boolean = true;
  teamtab = [
    { text: '小学组', id: '1' },
    { text: '中学组', id: '2' },
  ];
  teamType = '1';
  @Watch('idtype')
  handleTeamSearch() {
    this.page = 1;
    this.teamType = '1';
    this.id = this.idtype;
  }
  @Watch('id')
  handleSearch() {
    this.resetState();
  }
  changeTeamTab(item: any) {
    console.log('itemlog:', item.id);
    this.teamType = item.id;
    this.id = item.id;
  }
  resetState() {
    this.loading = false;
    this.finished = false;
    this.voteList = [];
    this.page = 1;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  clear() {
    this.resetState();
  }
  onSearch() {
    this.resetState();
  }
  userInputChange(text: string) {
    this.inputText = text;
  }
  onLoad() {
    getList(this.page, this.inputText, this.id).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.voteList = [...this.voteList, ...res.data];
    }
    this.loading = false;
  }
  goDetail(id: string) {
    this.$router.push(`detail?id=${id}`);
  }
  clickItem(item: any) {
    this.$router.push({
      path: 'detail',
      query: {
        id: item.id,
        tb: item.tb,
      },
    });
  }
}
